export const initializePendo = user => {
  const org =
    user?.Organizations?.filter(org => org.active)?.[0] ||
    user?.Organizations?.[0]

  let account = {}

  if (org) {
    account = {
      id: org.id,
      planLevel: org.active ? 'paying' : 'free',
      planPrice:
        org.planType === null
          ? 0
          : org.planType === 'pro' || org.planType === 'individual'
          ? 50
          : 200,
      creationDate: org.createdAt,
    }
  }

  const deviceType = window.innerWidth < 800 ? 'mobile' : 'desktop'

  const values = {
    account,
    visitor: {
      deviceType,
      id: user.id,
      email: user.email,
      role: user.admin ? 'admin' : 'user',
      screenWidth: window.innerWidth,
    },
  }

  if (process.env.NODE_ENV === 'production') {
    window.pendo.initialize(values)
  }
}
